import React, {Component} from 'react'
import { css } from 'emotion'
import { IntroTemplateStyle, Colors } from './../../styles'
import { ProgressBar } from './../../components'

export default class IntroTemplate extends Component {
  state = {

  }

  shouldComponentUpdate(){
    return false
  }
  
  render() {
    const { titleProduct, title, picture, items, type, sport, lifestyle, expert } = this.props
    return (
      <div className={`${IntroTemplateStyle(picture)} product-template product-template--intro`}>
        <div className="template-scroll">
          <div className="template-left template-content">
            <h2 className="title">{ titleProduct }</h2>
            <h3 className="subtitle"> { title } </h3>
            <div className="content">
              {
                type === 'introproduct' && (
                  <div className="content-row flex">
                    <div className="label">Class</div>
                    <div className="description">

                      <div className="flex">
                        <span className={ `range-label  ${css({ color: Colors.red})}`} > Sport </span>
                        <div className="range">
                          <ProgressBar theme={'red'} x={sport} big/>
                        </div>
                      </div>
                      <div className="flex">
                        <span className={ `range-label  ${css({ color: Colors.blue})}`} > Expert </span>
                        <div className="range">
                          <ProgressBar theme={'blue'} x={expert} big/>
                        </div>
                      </div>
                      <div className="flex">
                        <span className={ `range-label ${css({ color: Colors.green})}`} > Lifestyle </span>
                        <div className="range">
                          <ProgressBar theme={'green'} x={lifestyle} big/>
                        </div>
                      </div>

                    </div>
                  </div>
                )
              }
              {
                items && items.map((item, index) => (
                  <div className="content-row flex" key={index}>
                    <div className="label">{item.label}</div>
                    <div className="description"> { item.description } </div>
                  </div>
                ))
              }
            </div>
          </div>
          <div className="template-right"></div>
        </div>  
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SliderTemplates/IntroTemplate.js